import { render, staticRenderFns } from "./PublicMenu.vue?vue&type=template&id=2a67d98f&scoped=true&"
import script from "./PublicMenu.vue?vue&type=script&lang=js&"
export * from "./PublicMenu.vue?vue&type=script&lang=js&"
import style0 from "./PublicMenu.vue?vue&type=style&index=0&id=2a67d98f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a67d98f",
  null
  
)

export default component.exports